import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";

interface IYesNoModal {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
  message: string;
  title?: string;
}

export const YesNoModal: FC<IYesNoModal> = ({
  open,
  onYes,
  onNo,
  message,
  title,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onYes();
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
        isPrimary: false,
      },
      click: () => {
        onNo();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  return (
    <DialogComponent
      width="400px"
      close={onNo}
      header={title && title.length > 0 ? title : dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      {message}
    </DialogComponent>
  );
};
